<template>
  <div class="level_box">
    <div class="level">
        <div class="flex-center">
          <div class="name">
              产品分类
          </div>
          <span>：</span>
        </div>
        <div class="content"  v-for="(item, index) in list" :key="index" >
            <div
                :class="infoIndex == item.code ? 'item active_item' : 'item'"
                @click="handleSet(0, item.code, item.children)"
                >
                <span>{{ item.label }}</span>
            </div>
        </div>
    </div>
    <div class="level_box2" v-if="infoSecondShow">
      <div class="level">
          <div class="content"  v-for="(item, index) in childrenList" :key="index" >
              <div
                  :class="infoIndex2 == item.code ? 'item active_item' : 'item'"
                  @click="handleSet(1 , item.code, item.children)"
              >
              <span>{{ item.label }}</span>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    activeClass: String,
  },
  data() {
    return {
      typeList: [], //分类数据
      info: {},
      infoIndex: "",
      infoIndex2: "",
      infoSecondShow: false,
      childrenList: []
    };
  },
  mounted() {
    // this.getTypeList()
  },
  watch: {
    list: {
      handler(newval, oldval) {
        this.getTypeList();
      },
      deep: true,
      immediate: true,
    },
    infoIndex: {
      handler(newval) {
        // this.info = newval;
        this.$emit("levelChange", this.info);
      },
      deep: true,
    },
    infoIndex2: {
      handler(newval) {
        this.$emit("levelChange", this.info);
      },
      deep: true,
    },
  },
  methods: {
    //激活值
    handleSet(key, code, children) {
        if(code) {
            this.info[key] = code;
        } else {
            this.info[0] = "";
            this.info[1] = "";
        }
        if(key == 0) {
            this.infoIndex = code;
            this.infoIndex2 = "";
            this.info[1] = "";
            if(children) {
                this.infoSecondShow = true;
                this.childrenList = children
            }else {
                this.infoSecondShow = false 
                this.childrenList = []
            }
        }else {
            this.infoIndex2 = code;
            this.infoSecondShow = true;
        }
    },
    //树形结构分级 level代表层级
    arrayFlagLevel(array, level) {
      if (!array || !array.length) return;
      array.forEach((item) => {
        item.level = level;
        if (item.children && item.children.length) {
          this.arrayFlagLevel(item.children, level + 1);
        }
      });
    },
    //树形结构展开
    treeToArray(tree) {
      var res = [];
      for (const item of tree) {
        const { children, ...i } = item;
        if (children && children.length) {
          res = res.concat(this.treeToArray(children));
        }
        res.push(i);
      }
      return res;
    },
    getTypeList() {
    //   this.arrayFlagLevel(this.list, 0);
    //   let arr = this.treeToArray(JSON.parse(JSON.stringify(this.list)));
    //   let result = this.classifyArrayGroupBySameFieldAlpha(arr, "level");
    //   this.typeList = result.map((m) => {
    //     m.data.unshift({ label: "全部", code: "" });
    //     return {
    //       ...m,
    //     };
    //   });
      let obj = {};
      this.handleSet(0, this.activeClass);
      this.list.map((ele, ind) => {
        obj[ele.key] = "";
        if( ele.code == this.activeClass ){
            this.handleSet(0, this.activeClass, ele.children);
        }
      });
      this.info = obj;

    },
    //根据类型分组
    classifyArrayGroupBySameFieldAlpha(arr, filed) {
      let temObj = {};
      for (let i = 0; i < arr.length; i++) {
        let item = arr[i];
        if (!temObj[item[filed]]) {
          temObj[item[filed]] = [item];
        } else {
          temObj[item[filed]].push(item);
        }
      }
      let resArr = [];
      Object.keys(temObj).forEach((key) => {
        resArr.push({
          key: key,
          data: temObj[key],
        });
      });
      return resArr;
    },
  },
};
</script>

<style lang="less" scoped>
.flex-center {
    display: flex;
    align-items: center;
}
.level_box {
  padding: 10px;
  font-size: 14px;
  color: #333333;
  border: 1px solid #ddd;
  .level {
    display: flex;
    .name {
      // margin: 10px 0;
      padding: 5px 0;
      width: 58px;
      flex: 0 0 58px;
      text-align: justify;
      text-align-last: justify;
      text-justify: distribute-all-lines;
    }
    .content {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .item {
        width: fit-content;
        margin: 0 10px;
        padding: 0 10px;
        border-radius: 5px;
        cursor: pointer;
      }
      .item:hover {
        color: rgba(0, 153, 153, 1);
      }
      .active_item {
        color: rgba(0, 153, 153, 1);
      }
    }
  }
  .level_box2 {
    background: rgb(245, 247, 250);
    color: rgb(110, 110, 110);
    margin-left: 93px;
    border: none;
    padding-top: 0px;
     .content {
      .item {
        margin: 10px;
        padding: 5px 10px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/product/components/Level.vue